module.exports = __webpack_public_path__ + "static/media/eventos.6f4a0da7.png";